/**
 * Mapping between 2-character short codes and full app IDs.
 * Must match backend configuration.
 */

export const SHORT_CODE_TO_APP_ID: Record<string, string> = {
  mc: "mergecruise.sb.app",
  dt: "dev.test.app",
  dd: "test.app", // Domino Dreams (test)
  dc: "test.app2", // Dice Dreams (test)
  do: "domino.app",
  dp: "domino.prod.app",
  ds: "dice.sb.app",
  dr: "dice.prod.app",
  d1: "disney.sb.one.app",
  d2: "disney.sb.two.app",
  dy: "disney.prod.app",
};

/**
 * Get full app ID from 2-character short code.
 * Used to load game config before API call completes.
 */
export function getAppIdFromShortCode(shortCode: string): string | null {
  return SHORT_CODE_TO_APP_ID[shortCode] || null;
}

/**
 * Validate if short code has a mapping.
 */
export function isValidAppShortCode(shortCode: string): boolean {
  return shortCode in SHORT_CODE_TO_APP_ID;
}
